module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toolbar-inner bottomToolbarInner"
  }, _vm._l((_vm.bottomItemsData), function(item) {
    return _c('a', {
      staticClass: "toolbarBlock",
      class: {
        common_toolbar: item.isSelected
      },
      style: (_vm.backGroundClicked(item, item.active)),
      attrs: {
        "href": _vm.getLink(item.link, item.active),
        "id": item.id
      },
      on: {
        "click": function($event) {
          return _vm.printBackground(item.link, item.active)
        }
      }
    }, [_c('div', {
      staticClass: "toolbarBlockIconContainer"
    }, [_c('i', {
      staticClass: "icon toolbarBlockIcon",
      class: _vm.isWhite(item)
    })]), _vm._v(" "), _c('div', {
      staticClass: "toolbarBlockLabel",
      class: {
        label_toolbar_selected: item.isSelected, label_toolbar: !item.isSelected
      },
      attrs: {
        "id": item.idLabel
      }
    }, [_vm._v("\n        " + _vm._s(_vm.$t(item.label)) + "\n   ")])])
  }), 0)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-bca4ee04", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bca4ee04","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bottomToolbar/itemsBottombar.vue
// module id = 2435
// module chunks = 2